export default __webpack_public_path__ + "static/hummingbird-3822e7d5c46f4ee3bc7ff89098d5fe14.png";